// Constructor
function Farmer(app) {
	this.app = app;
	this.data = false;
	this.currentScreenData = false;
	this.currentDialogIndex = false;
	this.animationEngine = false;
	this.sex = "male";

	this.loadData();
}

Farmer.prototype.loadData = function (gameName) {
	$.ajax({
		url: "farmer.html",
		dataType: 'html',
		cache: false,
		complete: $.proxy(function (data, textStatus) {
			$("#game").html(data.responseText);
			// this.app.initSVG();

			$.ajax({
				url: "farmer.json",
				dataType: 'json',
				cache: false,
				complete: $.proxy(function (data) {
					this.data = JSON.parse(data.responseText);
					this.init();
				}, this)
			});

		}, this)
	});
};

Farmer.prototype.init = function () {

	this.app.initSVG();

	this.animationEngine = new AnimationEngine(this.app, this);

	$(".guide").hide();

	// Init perso plugin
	$(".perso").each(function (i, n) {
		var type = $(n).data("type");
		$(n).perso({
			type: type,
			talk: false
		});
	});

	$("#choices li").on("click", $.proxy(this.selectChoice, this))

	// Definititons
	$("#farmer-screen, #explanations-screen").on('click', ".def", $.proxy(function (e) {
		var defId = $(e.currentTarget).data("def");
		this.showLexique(defId);
	}, this));

	this.setDefaultData();

};

Farmer.prototype.initScene = function (scene) {

	// Set the season
	$("#farmer-scene").removeClass("autumn summer spring winter").addClass(scene.season);

	// set sun
	$("#farmer-scene .sun").removeClass("small big").addClass(scene.sun);

	this.animationEngine.initScene(scene);
};


Farmer.prototype.setData = function (data) {

	console.log("set data", data)

	// Season
	var season = data["season"];
	$("#farmer-data-season").removeClass("winter autumn summer spring").addClass(season);

	// Yields, costs and co2
	var dataNames = ['yields', 'costs', 'co2'];
	var dataTotal = [40000, 187, 440];
	for (var i = 0; i < dataNames.length; i++) {
		var dataName = dataNames[i];
		var dataValue = data[dataNames[i]];
		var dataValueNorm = Math.round((dataValue["value"] / dataTotal[i]) * 100) / 100;
		// console.log(dataName, dataValue, dataTotal[i], dataValueNorm)
		$("#farmer-data-" + dataName + " .arrow").removeClass("positive negative neutral").addClass(dataValue["dir"]);
		$("#farmer-data-" + dataName + " .fill").height($("#farmer-data-" + dataName).height() * dataValueNorm);

		// var availableHeight = ($("#result-data-" + dataName + " .square").outerHeight(true, true) - $("#result-data-" + dataName + " .title").outerHeight(true, true));
		var availableHeight = 276;
		$("#result-data-" + dataName + " .fill").height(availableHeight * dataValueNorm);
	}
};

Farmer.prototype.setDefaultData = function () {

	this.setData({
		co2: {
			dir: "neutral",
			value: 0
		},
		costs: {
			dir: "neutral",
			value: 0
		},
		yields: {
			dir: "neutral",
			value: 0
		},
		season: "autumn"
	});
}

Farmer.prototype.start = function () {

	console.log("Start Farmer");

	$("#title-screen").fadeOut("normal", $.proxy(function () {
		$("#title-screen").removeClass("active");
		$("#persos-screen").addClass("active").fadeTo("normal", 1);
		// this.gotoLastScreen();
		// this.gotoResults();
		// this.gotoGame();
	}, this));
};


Farmer.prototype.gotoExplanation = function (selection) {

	console.log("go to explanation screens", selection);

	// Save sex
	this.sex = selection;

	// Add body class
	$("body").removeClass("male female").addClass(selection);

	// Show help
	this.showHelp();

	// On help close
	$(document).one("closeModal", $.proxy(function () {
		$("#persos-screen").fadeOut("normal", $.proxy(function () {
			$("#persos-screen").removeClass("active");
			$("#explanations-screen").addClass("active").fadeTo("normal", 1);
		}, this));
	}, this));
};


Farmer.prototype.gotoGame = function () {

	console.log("go to game screen");

	$("#explanations-screen").fadeOut("normal", $.proxy(function () {
		$("#explanations-screen").removeClass("active");
		$("#farmer-screen").addClass("active").fadeTo("normal", 1);
		this.gotoScreen("4");
		// this.gotoScreen("11A");
	}, this));
};


Farmer.prototype.gotoScreen = function (screenCode) {
	console.log(" gotoScreen screenCode", screenCode)
	this.currentScreenData = this.data["screens"][screenCode];
	this.currentDialogIndex = -1;
	this.nextDialog();

	this.initScene(this.currentScreenData["scene"]);
	this.setData(this.currentScreenData["data"]);
};


Farmer.prototype.gotoResults = function (resultId) {

	console.log("goto results", resultId)

	// Add sex to perso
	$("#results-screen .result-perso").removeClass("male female").addClass(this.sex);

	// Add appreciation to perso
	$("#results-screen .result-perso").removeClass("negative positive").addClass("positive");

	// Apply results data to results screen
	$("#results-screen .result-item.yields .description .fr").text(this.data["results"][resultId]["yields_fr"]);
	$("#results-screen .result-item.yields .description .en").text(this.data["results"][resultId]["yields_en"]);
	$("#results-screen .result-item.costs .description .fr").text(this.data["results"][resultId]["costs_fr"]);
	$("#results-screen .result-item.costs .description .en").text(this.data["results"][resultId]["costs_en"]);
	$("#results-screen .result-item.co2 .description .fr").text(this.data["results"][resultId]["co2_fr"]);
	$("#results-screen .result-item.co2 .description .en").text(this.data["results"][resultId]["co2_en"]);
	$("#results-screen #result-subtitle .fr").text(this.data["results"][resultId]["subtitle_fr"]);
	$("#results-screen #result-subtitle .en").text(this.data["results"][resultId]["subtitle_en"]);
	// $(".result-perso .text p.en").text(this.data["results"][resultId]["summary"]);
	// $(".result-perso .text p.fr").text(this.data["results"][resultId]["summary"]);

	$("#farmer-screen").fadeOut("normal", $.proxy(function () {
		$("#farmer-screen").removeClass("active");
		$("#results-screen").addClass("active").fadeTo("normal", 1);
	}, this));
};


Farmer.prototype.gotoLastScreen = function (resultId) {

	console.log("goto last screen");

	// // Add sex to perso
	$("#last-screen").removeClass("male female").addClass(this.sex);

	// Animate
	$("#results-screen").fadeOut("normal", $.proxy(function () {
		$("#results-screen").removeClass("active");
		$("#last-screen").addClass("active").fadeTo("normal", 1);
	}, this));
};


Farmer.prototype.nextDialog = function () {

	console.log("currentScreenData", this.currentScreenData)
	console.log("currentDialogIndex", this.currentDialogIndex)

	// Define useful variables
	this.currentDialogIndex++;
	var dialog = this.currentScreenData["dialogs"][this.currentDialogIndex];

	// Hide
	$("#perso").addClass("hide");
	$("#perso").perso("shutUp");
	$("#dialog").addClass("hide");

	// Show
	requestTimeout($.proxy(function (dialog) {

		// Check if we need to show choices
		if (typeof this.currentScreenData["automatic_goto"] === "undefined") {
			if (this.currentDialogIndex >= this.currentScreenData["dialogs"].length) {
				if (typeof this.currentScreenData["after_dialogs_goto"] === "undefined") {
					// Show choices
					this.gotoChoices();
					return;
				} else if (this.currentScreenData["after_dialogs_goto"].substr(0, 7) == "results") {
					// Go to results
					var resultId = this.currentScreenData["after_dialogs_goto"].substr(8, 3);
					this.gotoResults(resultId);
					return;
				} else if (typeof this.currentScreenData["after_dialogs_goto"] !== "undefined") {
					this.gotoScreen(this.currentScreenData["after_dialogs_goto"]);
					return;
				}
			}
		}

		// Handle dialog
		if (dialog) {
			$("#dialog .dialog-content .fr").html(dialog["content_fr"]);
			$("#dialog .dialog-content .en").html(dialog["content_en"]);
			$("#dialog #perso-title .fr").html(dialog["title_fr"]);
			$("#dialog #perso-title .en").html(dialog["title_en"]);
			$("#dialog").removeClass("right left ").addClass(dialog["position"]);
			$("#dialog").removeClass("hide");

			// Female switch
			var type = dialog["type"];
			if (type == "farmer" && this.sex == "female") {
				type = "farmer1"
			}

			// Handle perso
			$("#perso").alterClass("type-*").addClass("type-" + type);
			$("#perso").removeClass("right left").addClass(dialog["position"]);
			$("#perso").removeClass("hide");
			$("#perso").perso("talk");
		}

	}, this, dialog), 700)

};


Farmer.prototype.gotoChoices = function (screenCode) {

	var choices = this.currentScreenData["choices"];

	// Create choices
	for (var i = 0; i < $("#choices li").length; i++) {
		if (typeof choices[i] != "undefined") {
			$("#choices li").eq(i).show();
			$("#choices li").eq(i).data("goto", choices[i].goto);
			$("#choices li").eq(i).find(".fr").html(choices[i]["title_fr"]);
			$("#choices li").eq(i).find(".en").html(choices[i]["title_en"]);
		} else {
			$("#choices li").eq(i).hide();
		}
	}

	// Show modal
	this.app.showModal("#choices");
};


Farmer.prototype.selectChoice = function (e) {
	this.app.closeModal("#choices");
	this.gotoScreen($(e.currentTarget).data("goto"));
};


Farmer.prototype.showLexique = function (defId) {

	// Get definition
	var definition = this.data["definitions"]["def" + defId];

	// Add title
	$("#lexique h2.fr").html(definition["title_fr"]);
	$("#lexique h2.en").html(definition["title_en"]);

	// Add content
	$("#lexique .content .fr").html(definition["content_fr"]);
	$("#lexique .content .en").html(definition["content_en"]);

	// Show modal
	this.app.showModal("#lexique");
}


Farmer.prototype.closeLexique = function () {
	this.app.closeModal("#lexique");
}


Farmer.prototype.showHelp = function () {
	this.app.showModal("#help");
}


Farmer.prototype.closeHelp = function () {
	this.app.closeModal("#help");
}


Farmer.prototype.reset = function () {

	this.sex = "male";
	this.currentScreenData = false;
	this.currentDialogIndex = false

	// Set default data
	this.setDefaultData()

	// Reset is called when returning to screensaver

	// Close help
	// this.closeHelp();

	// Close sources
	// this.closeSource();

	// Close lexiqe
	this.closeLexique();

	// Animate in/out and reset classes
	$(".screen.active").fadeOut("normal", $.proxy(function () {
		$(".screen").removeClass("active");
		$("#title-screen").addClass("active").fadeTo("normal", 1);
	}, this));

	this.animationEngine.killTweens();

};


// Expose Farmer
window.Farmer = Farmer;
